import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const preloadMainJs = () => {
  const scriptElements = document.getElementsByTagName('script');
  const mainJsFile = Array.from(scriptElements).find(script => 
    script.src.includes('main') && script.src.endsWith('.js')
  );

  if (mainJsFile) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = mainJsFile.src;
    link.as = 'script';
    document.head.appendChild(link);
  }
};

// Call the preload function
preloadMainJs();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
